import Cookies from 'js-cookie';
import { up } from 'slide-element';

const dismissedAlerts = JSON.parse(Cookies.get('dismissedAlerts') || null) || [];
const $alerts = document.querySelectorAll('.alert');

$alerts.forEach(($alert) => {
    const alertId = $alert.dataset.id;
    const $btnClose = $alert.querySelector('.btn-close');
    const $currentAlert = $alert;

    if (dismissedAlerts.includes(alertId)) $currentAlert.style.display = 'none';

    $btnClose.addEventListener('click', () => {
        up($currentAlert);
        dismissedAlerts.push(alertId);
        Cookies.set('dismissedAlerts', JSON.stringify(dismissedAlerts), {
            expires: 365,
        });
    });
});
